module.exports = __webpack_public_path__ + "img/photo-64.a925ed4a.webp";